import React from 'react'
import Header from './Header'
import FooterArea from './Footer'
import { Outlet } from 'react-router-dom';


const Layout = () => {
  return (
    <>
      <div className="container mx-auto p-2 mb-10">
        <Header />

        <main>
          <Outlet />
        </main>

      </div>
      <FooterArea />
    </>
  )
}

export default Layout
